import { DateTime } from 'luxon';
import type { Document } from '@getaccept/lib-shared/src/types/Document';
import type { UpdateDocumentPatch } from '@getaccept/lib-shared/src/types/update-document-patch';
import type { DocumentListItem } from '@getaccept/lib-shared/src/types/document-list-item';

export class DocumentHelper {
  // eslint-disable-next-line sonarjs/cognitive-complexity
  static updatedDocumentFromPatch(document: Document, patch: UpdateDocumentPatch): Document {
    return {
      ...document,
      name: 'name' in patch ? patch.name : document.name,
      type: 'type' in patch ? patch.type : document.type,
      companyName: 'companyName' in patch ? patch.companyName : document.companyName,
      contractStartDate:
        'contractStartDate' in patch
          ? DateTime.fromMillis(patch.contractStartDate).toISO()
          : document.contractStartDate,
      contractEndDate:
        'contractEndDate' in patch
          ? DateTime.fromMillis(patch.contractEndDate).toISO()
          : document.contractEndDate,
      value: 'value' in patch ? patch.value : document.value,
      expirationDate:
        'expirationDate' in patch
          ? DateTime.fromMillis(patch.expirationDate).toISO()
          : document.expirationDate,
      isSigningInitials:
        'isSigningInitials' in patch ? patch.isSigningInitials : document.isSigningInitials,
      isSigningBiometric:
        'isSigningBiometric' in patch ? patch.isSigningBiometric : document.isSigningBiometric,
      isSigningForward:
        'isSigningForward' in patch ? patch.isSigningForward : document.isSigningForward,
      isPrivate: 'isPrivate' in patch ? patch.isPrivate : document.isPrivate,
      isSigning: 'isSigning' in patch ? patch.isSigning : document.isSigning,
      isSelfsign: 'isSelfsign' in patch ? patch.isSelfsign : document.isSelfsign,
      isIdentifyRecipient:
        'isIdentifyRecipient' in patch ? patch.isIdentifyRecipient : document.isIdentifyRecipient,
      isAutoComment: 'isAutoComment' in patch ? patch.isAutoComment : document.isAutoComment,
      isAutoCommentEmail:
        'isAutoCommentEmail' in patch ? patch.isAutoCommentEmail : document.isAutoCommentEmail,
      isSmsSending: 'isSmsSending' in patch ? patch.isSmsSending : document.isSmsSending,
      isScheduledSending:
        'isScheduledSending' in patch ? patch.isScheduledSending : document.isScheduledSending,
      autoCommentEmail:
        'autoCommentEmail' in patch ? patch.autoCommentEmail : document.autoCommentEmail,
      autoCommentText:
        'autoCommentText' in patch ? patch.autoCommentText : document.autoCommentText,
      externalEditorId:
        'externalEditorId' in patch ? patch.externalEditorId : document.externalEditorId,
      externalEditorType:
        'externalEditorType' in patch ? patch.externalEditorType : document.externalEditorType,
      isSigningOrder: 'isSigningOrder' in patch ? patch.isSigningOrder : document.isSigningOrder,
      isSmsReminder: 'isSmsReminder' in patch ? patch.isSmsReminder : document.isSmsReminder,
      isReminderSending:
        'isReminderSending' in patch ? patch.isReminderSending : document.isReminderSending,
      reminderOpened: 'reminderOpened' in patch ? patch.reminderOpened : document.reminderOpened,
      reminderOpenedDays:
        'reminderOpenedDays' in patch ? patch.reminderOpenedDays : document.reminderOpenedDays,
      reminderSigned: 'reminderSigned' in patch ? patch.reminderSigned : document.reminderSigned,
      reminderSignedDays:
        'reminderSignedDays' in patch ? patch.reminderSignedDays : document.reminderSignedDays,
      reminderRepeat: 'reminderRepeat' in patch ? patch.reminderRepeat : document.reminderRepeat,
      reminderRepeatDays:
        'reminderRepeatDays' in patch ? patch.reminderRepeatDays : document.reminderRepeatDays,
      reminderExpiration:
        'reminderExpiration' in patch ? patch.reminderExpiration : document.reminderExpiration,
      reminderExpirationDays:
        'reminderExpirationDays' in patch
          ? patch.reminderExpirationDays
          : document.reminderExpirationDays,
      scheduledSendingTime:
        'scheduledSendingTime' in patch
          ? DateTime.fromMillis(patch.scheduledSendingTime).toISO()
          : document.scheduledSendingTime,
      scheduledSendingDate:
        'scheduledSendingDate' in patch
          ? DateTime.fromMillis(patch.scheduledSendingDate).toISO()
          : document.scheduledSendingDate,
    };
  }

  static updateDocumentListItemFromPatch(
    document: DocumentListItem,
    patch: UpdateDocumentPatch
  ): DocumentListItem {
    return {
      ...document,
      name: 'name' in patch ? patch.name : document.name,
      type: 'type' in patch ? patch.type : document.type,
      value: 'value' in patch ? patch.value : document.value,
      expirationDate: 'expirationDate' in patch ? patch.expirationDate : document.expirationDate,
      isPrivate: 'isPrivate' in patch ? patch.isPrivate : document.isPrivate,
    };
  }
}
